import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const QuizWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  max-width: 840px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  overflow-y: auto;
  padding: 24px 0;
`;
